import { Components as UiComponents } from 'truefuture-ui'

export default (app) => {
    // COMPONENTS
    Object.keys(UiComponents).forEach((key) => {
        app.component(key, UiComponents[key])
    }, UiComponents)
}